import AppLoader from "@/components/AppLoader";
import authStore from "@/stores/authStore";
import { useSelector } from "@tanstack/react-store";
import { Navigate, Outlet } from "react-router-dom";
import routes from "../router/routes";

/*
 * OIDC / Keycloak + consent gate
 *
 * Do not navigate to /login while the URL still carries an OIDC callback; the SDK
 * must process `code` first. We detect callback via merged search + hash params.
 *
 * Consent (`userConsentsAreAccepted`) is resolved in DidomiConsent once Didomi + the
 * Mailvista consentManager are ready (see mobile RouteManager: same signals).
 * ---------------------------------------------------------------------------
 */

const CheckConsent = () => {
    const userConsentsAreAccepted = useSelector(
        authStore,
        (state) => state.userConsentsAreAccepted,
    );

    if (userConsentsAreAccepted === null) {
        return <AppLoader />;
    }

    if (userConsentsAreAccepted) {
        return <Outlet />;
    }

    return <Navigate to={routes.askConsent} replace />;
};

export default CheckConsent;
